<template lang="pug">
  .component-tabbed-vehicle-costs(v-if="roi")
    .action-bar
      .title
        h2 Vehicle Costs
      .action
        modal-reveal(sizing="small", ref="modalAddCost")
          div.text-right(slot="trigger")
            i.fa.fa-plus-circle.fa-2x
          h2 Add cost
          .row
            .columns.small-6
              label Cost Type
                select(v-model="cost.asset_cost_record_type_id")
                  option(v-for="costType in costTypes", :value="costType.id") {{costType.name}}
              label Amount
                input(type="number", v-model="cost.amount")
              label Date
                date-picker(v-model="cost.date")
            .columns.small-6
              label Description
                input(type="text", v-model="cost.description")
              label Vat %
                input(type="text", v-model="vatRate")


          .row
            .columns
              button.button(:disabled="!cost.asset_cost_record_type_id || !cost.amount || !cost.description", @click="addCost") Save

    .container
      .tabs-inner-content
        .row
          .columns.text-center
            Label Select range
            RangePicker(@input="setDates", :start-date="search.start", :end-date="search.end")
        .row
          .columns.small-6.text-center
            .card
              .inner-content
                span Reservations
                h3 {{currency}}{{Math.ceil(roi.reservation_amount)}}
          .columns.small-6.text-center
            .card
              .inner-content
                span Costs
                h3 {{currency}}{{Math.ceil(roi.costs_amount)}}


    base-list(:component="component", :dataLoader="dataLoader", :search="search", :showPerPageSelect="false", ref="list")
      header-columns(slot="before", :columns="headers")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import StatisticsCard4 from '../../structure/ui/StatisticsCard4'
  import moment from 'moment'
  import VehicleCost from '../VehicleCost'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import CardN from '../../structure/CardN'
  import DatePicker from '../../structure/DatePicker'
  import BaseList from '../../../pages/backoffice/BaseList'
  import HeaderColumns from '../../structure/ui/HeaderColumns'
  import {mapState} from 'vuex'
  import RangePicker from '../../structure/RangePicker'

  export default {
    name: 'TabbedVehicleCosts',
    components: {
      RangePicker,
      HeaderColumns,
      BaseList,
      DatePicker,
      CardN,
      ModalReveal,
      VehicleCost,
      StatisticsCard4,
    },
    data() {
      return {
        roi: null,
        costTypes: [],
        cost: {
          asset_cost_record_type_id: null,
          description: null,
          amount: null,
          tax: null,
          date: null,
        },
        vatRate: 0,
        headers: ['', 'Cost type', 'Description', 'Amount & Tax', 'Date'],
        search: {start: null, end: null},
        component: require('src/components/backoffice/VehicleCost'),
      }
    },
    created() {
      this.search.start = moment().startOf('month').format('YYYY-MM-DD')
      this.search.end = moment().format('YYYY-MM-DD')
      this.vatRate = this.configuration.commercial.commercial_vat_rate.value
      this.init()
      this.loadCostTypes()
    },
    methods: {
      setDates(range) {
        this.search.start = range.from
        this.search.end = range.to
      },
      init() {
        this.loadRoi()
      },
      loadRoi() {
        KeplerBackofficeSdk.vehicles.select(this.$route.params.id).roi(this.search.start, this.search.end, (data) => {
          this.roi = data
        })
      },
      loadCostTypes() {
        KeplerBackofficeSdk.assetCosts.list.types((data) => {
          this.costTypes = data
        })
      },
      addCost() {

        this.cost.tax = this.cost.amount * this.vatRate
        KeplerBackofficeSdk.vehicleCost.make(this.$route.params.id, this.cost, () => {
          this.$refs.modalAddCost.close()
          this.$refs.list.loadData(1)
          this.init()
        })
      },
      dataLoader(callback) {
        var costs = {
          current_page: 1,
          current_page_count: 1,
          items: [],
          items_count: 0,
          page_count: 1,
          per_page_count: 25,
        }
        KeplerBackofficeSdk.vehicles.select(this.$route.params.id).costs(this.search.start, this.search.end, (data) => {
          costs.items_count = data.length
          costs.items = data
          this.loadRoi()
          callback(costs)
        })
      },
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },

    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-costs
    width: 100%
    padding-bottom: 25px

    .container
      margin: 20px

    .roi
      .inner-content
        padding-top: 0
</style>



// WEBPACK FOOTER //
// VehicleCosts.vue?47d7354b